module.exports = __webpack_public_path__ + "img/apartment-architecture-bookcase-bookshelves-271816.c4617b36.jpg";